import {
  InvoiceListAgingBucket,
  InvoiceListRecordType,
  InvoiceListSortDirection,
  InvoiceListSortField,
} from '@/types';

export interface UnpaidInvoiceListFilterParams {
  overdue_bucket?: InvoiceListAgingBucket;
  record_type?: InvoiceListRecordType;
}

export interface UnpaidInvoiceListSortParams {
  sort_by: InvoiceListSortField;
  sort_direction: InvoiceListSortDirection;
}

export interface UnpaidInvoiceRow {
  amountPaidLabel: string | null;
  customerName: string;
  daysOverdue: number;
  dueDateLabel: string;
  erpLastSyncedDateLabel: string | null;
  erpLastSyncedTimeLabel: string | null;
  invoiceNumber: string;
  recordType: InvoiceListRecordType;
  /** Negative (e.g. "-$450.00") for credit memos. */
  remainingBalanceLabel: string;
}

export type UnpaidInvoiceRecordTypeFilter = 'all' | 'creditMemos' | 'invoices';

export interface UnpaidInvoiceFilters {
  recordType: UnpaidInvoiceRecordTypeFilter;
}

export const DEFAULT_UNPAID_INVOICE_FILTERS: UnpaidInvoiceFilters = {
  recordType: 'all',
};

export type UnpaidInvoiceSortField =
  | 'customerName'
  | 'daysOverdue'
  | 'dueDate'
  | 'erpLastSyncedAt'
  | 'invoiceNumber'
  | 'remainingBalance';

export interface UnpaidInvoiceSort {
  direction: 'asc' | 'desc';
  field: UnpaidInvoiceSortField;
}
